/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_DensityInputs */

const en_disp_density = /** @type {(inputs: Disp_DensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Density`)
};

const de_disp_density = /** @type {(inputs: Disp_DensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dichte`)
};

/**
* | output |
* | --- |
* | "Density" |
*
* @param {Disp_DensityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_density = /** @type {((inputs?: Disp_DensityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_DensityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_density(inputs)
	return en_disp_density(inputs)
});